import { createReducer, on, Action } from '@ngrx/store';
import * as appActions from './app.actions';

export interface ReducerAppState {
  showPlansButton: boolean;
  showTourPlanningMenu: boolean;
  showDocHistoryDropdown: boolean;
  docHistory: any[];
}

export const appInititalState: ReducerAppState = {
  showPlansButton: true,
  showTourPlanningMenu: false,
  showDocHistoryDropdown: false,
  docHistory: []
};

const appReducerInternal = createReducer(
  appInititalState,
  on(appActions.setShowPlansButton, (state, { payload }) => ({
    ...state,
    showPlansButton: payload
  })),
  on(appActions.setTourToPlanningMenu, (state) => ({
    ...state,
    showTourPlanningMenu: true
  })),
);

export function appReducer(
  state: ReducerAppState | undefined,
  action: Action
) {
  return appReducerInternal(state, action);
};
